/**
 * @link https://stackoverflow.com/a/46455994/1847705
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'approval' } )
export class ApprovalPipe implements PipeTransform {
    
    transform( pIsApproved: boolean ): string {
        if ( pIsApproved != null ) {
            return pIsApproved === true ? 'Approved' : 'Rejected';
        }
        return 'Pending';
    }
}
